// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__3ret0","videoPanel":"Video_videoPanel__32I9A","title":"Video_title__6NNmA"};